module.exports = __webpack_public_path__ + "img/any-mask1.cd1262fb.png";